import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import { fetchReplacement, updateReplacement } from '../actions/replacements'
import '../styles/ReplacementsView.css'

class replacementsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      editingField: null,   // e.g. "LOCK_MAIN"
      editingValue: '',
      saving: false,
      savedField: null,     // briefly set after a successful save
    }

    this.startEdit = this.startEdit.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.commitEdit = this.commitEdit.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    this.props.fetchReplacement("64cca358874b8124a31919ab")
  }

  startEdit(field, currentPrice) {
    this.setState({ editingField: field, editingValue: String(currentPrice), saving: false })
  }

  cancelEdit() {
    this.setState({ editingField: null, editingValue: '', saving: false })
  }

  commitEdit() {
    const { editingField, editingValue } = this.state
    const { replacement, updateReplacement } = this.props

    if (!editingField) return

    const parsed = parseFloat(editingValue)
    if (isNaN(parsed) || parsed < 0) {
      this.cancelEdit()
      return
    }

    // Build a shallow copy of the replacement with the updated nested field
    const updated = {
      ...replacement,
      [editingField]: {
        ...replacement[editingField],
        Price: parsed,
      },
    }

    this.setState({ saving: true, editingField: null, editingValue: '' })

    updateReplacement(replacement._id, updated).then(() => {
      this.setState({ savedField: editingField, saving: false })
      // Remove the "saved" highlight after animation completes
      setTimeout(() => this.setState(s => s.savedField === editingField ? { savedField: null } : null), 1300)
    }).catch(() => {
      this.setState({ saving: false })
    })
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); this.commitEdit() }
    if (e.key === 'Escape') this.cancelEdit()
  }

  // Renders either a clickable price badge or an inline input
  renderPrice(field, price) {
    const { editingField, editingValue, saving, savedField } = this.state

    if (editingField === field) {
      return (
        <span className="rep-price-edit">
          <input
            className="rep-price-input"
            type="number"
            step="0.01"
            min="0"
            value={editingValue}
            autoFocus
            onChange={e => this.setState({ editingValue: e.target.value })}
            onKeyDown={this.handleKeyDown}
            onBlur={this.commitEdit}
          />
          <button className="rep-price-save-btn" onMouseDown={e => { e.preventDefault(); this.commitEdit() }} title="Guardar">
            <i className="fas fa-check" />
          </button>
          <button className="rep-price-cancel-btn" onMouseDown={e => { e.preventDefault(); this.cancelEdit() }} title="Cancelar">
            <i className="fas fa-times" />
          </button>
        </span>
      )
    }

    const isSaved = savedField === field
    const isSaving = saving

    return (
      <span
        className={`rep-item-price${isSaved ? ' saved' : ''}${isSaving ? ' saving' : ''}`}
        onClick={() => !saving && this.startEdit(field, price)}
        title="Haz clic para editar"
      >
        {price.toFixed(2)}€
        <i className="fas fa-pencil-alt edit-hint" />
      </span>
    )
  }

  render() {
    const { replacement, error, loading } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!replacement || loading) {
      return <LoadingProgress />
    }

    return (
      <div className="replacements-view">

        {/* ── Header ── */}
        <div className="rep-header">
          <div className="rep-header-content">
            <div className="rep-header-text">
              <h1><i className="fas fa-tools"></i>Recambios</h1>
              <p className="rep-subtitle">Haz clic en cualquier precio para editarlo</p>
            </div>
          </div>
        </div>

        {/* ── Category cards ── */}
        <div className="rep-categories-grid">

          {/* Taquilla */}
          <div className="rep-category-card">
            <div className="rep-category-header">
              <i className="fas fa-lock"></i>Taquilla
            </div>
            <div className="rep-items-list">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/CIERRE-CENTRALITA.png" alt="Centralita" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Centralita</span>
                  {this.renderPrice('LOCK_MAIN', replacement.LOCK_MAIN.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/CIERRE-TECLADO CON CABLE.png" alt="Teclado" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Teclado</span>
                  {this.renderPrice('LOCK_PINPAD', replacement.LOCK_PINPAD.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/CIERRE-CIERRE FIJO.png" alt="Cierre fijo" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Cierre fijo</span>
                  {this.renderPrice('LOCK_ANCHORAGE', replacement.LOCK_ANCHORAGE.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/LOCK_PLATEN.png" alt="Pletina" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Pletina</span>
                  {this.renderPrice('LOCK_PLATEN', replacement.LOCK_PLATEN.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/BATERÍAS INDUSTRIALES.png" alt="Baterías" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Baterías</span>
                  {this.renderPrice('BATTERIES', replacement.BATTERIES.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/BISAGRA.png" alt="Bisagra" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Bisagra</span>
                  {this.renderPrice('HINGE', replacement.HINGE.Price)}
                </div>
              </div>
            </div>
          </div>

          {/* Kiosco */}
          <div className="rep-category-card">
            <div className="rep-category-header">
              <i className="fas fa-desktop"></i>Kiosco
            </div>
            <div className="rep-items-list">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/PANTALLA.png" alt="Pantalla" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Pantalla</span>
                  {this.renderPrice('KIOSC_SCREEN', replacement.KIOSC_SCREEN.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/SOPORTE ENTRADA MONEDAS.png" alt="Entrada monedas" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Entrada monedas COINCO</span>
                  {this.renderPrice('KIOSC_COINCO_COIN_ENTRY', replacement.KIOSC_COINCO_COIN_ENTRY.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/SOPORTE SALIDA MONEDAS.png" alt="Salida monedas" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Salida monedas COINCO</span>
                  {this.renderPrice('KIOSC_COINCO_COIN_EXIT', replacement.KIOSC_COINCO_COIN_EXIT.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/PCB.png" alt="Placa control" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Placa control</span>
                  {this.renderPrice('KIOSC_PCB', replacement.KIOSC_PCB.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/ESPRESSIF.png" alt="Espressif" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Espressif</span>
                  {this.renderPrice('KIOSC_ESPRESSIF', replacement.KIOSC_ESPRESSIF.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/HUB.png" alt="Hub USB" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Hub USB</span>
                  {this.renderPrice('KIOSC_HUB', replacement.KIOSC_HUB.Price)}
                </div>
              </div>
            </div>
          </div>

          {/* Métodos de pago */}
          <div className="rep-category-card">
            <div className="rep-category-header">
              <i className="fas fa-credit-card"></i>Métodos de pago
            </div>
            <div className="rep-items-list">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/COINCO.png" alt="Coinco" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Coinco</span>
                  {this.renderPrice('PAYMENT_COINCO', replacement.PAYMENT_COINCO.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/NV9USB.png" alt="NV9USB" />
                <div className="rep-item-info">
                  <span className="rep-item-name">NV9USB</span>
                  {this.renderPrice('PAYMENT_NV9USB', replacement.PAYMENT_NV9USB.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/SPU90.png" alt="SPu90" />
                <div className="rep-item-info">
                  <span className="rep-item-name">SPu90</span>
                  {this.renderPrice('PAYMENT_SPU90', replacement.PAYMENT_SPU90.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/hopper.png" alt="Hopper" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Hopper</span>
                  {this.renderPrice('PAYMENT_HOPPER', replacement.PAYMENT_HOPPER.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/U1000.png" alt="U1000" />
                <div className="rep-item-info">
                  <span className="rep-item-name">U1000</span>
                  {this.renderPrice('PAYMENT_U1000', replacement.PAYMENT_U1000.Price)}
                </div>
              </div>
            </div>
          </div>

          {/* Impresoras + Otros stacked */}
          <div className="rep-category-col">
            <div className="rep-category-card">
              <div className="rep-category-header">
                <i className="fas fa-print"></i>Impresoras
              </div>
              <div className="rep-items-list">
                <div className="rep-item">
                  <img className="rep-item-img" src="/images/replacements/CASHINO.png" alt="Cashino" />
                  <div className="rep-item-info">
                    <span className="rep-item-name">Cashino</span>
                    {this.renderPrice('PRINTER_CASHINO', replacement.PRINTER_CASHINO.Price)}
                  </div>
                </div>
                <div className="rep-item">
                  <img className="rep-item-img" src="/images/replacements/BROTHER.png" alt="Brother" />
                  <div className="rep-item-info">
                    <span className="rep-item-name">Brother</span>
                    {this.renderPrice('PRINTER_BROTHER', replacement.PRINTER_BROTHER.Price)}
                  </div>
                </div>
              </div>
            </div>
            <div className="rep-category-card">
              <div className="rep-category-header">
                <i className="fas fa-box"></i>Otros
              </div>
              <div className="rep-items-list">
                <div className="rep-item">
                  <img className="rep-item-img" src="/images/replacements/USB_WIRE.png" alt="Cable USB" />
                  <div className="rep-item-info">
                    <span className="rep-item-name">Cable USB</span>
                    {this.renderPrice('USB_WIRE', replacement.USB_WIRE.Price)}
                  </div>
                </div>
                <div className="rep-item">
                  <img className="rep-item-img" src="/images/replacements/LOCK_NUMBER.png" alt="Número" />
                  <div className="rep-item-info">
                    <span className="rep-item-name">Número</span>
                    {this.renderPrice('LOCK_NUMBER', replacement.LOCK_NUMBER.Price)}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* ── Doors ── */}
        <div className="rep-doors-card">
          <div className="rep-category-header">
            <i className="fas fa-door-open"></i>Puertas
          </div>
          <div className="rep-doors-grid">
            <div className="rep-doors-col">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/BASICA.png" alt="Standard" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Standard</span>
                  {this.renderPrice('DOOR_BNS', replacement.DOOR_BNS.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/BASICA.png" alt="Standard XL" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Standard XL</span>
                  {this.renderPrice('DOOR_BWS', replacement.DOOR_BWS.Price)}
                </div>
              </div>
            </div>
            <div className="rep-doors-col">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/GRANDE.png" alt="Medium" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Medium</span>
                  {this.renderPrice('DOOR_BNM', replacement.DOOR_BNM.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/GRANDE.png" alt="Medium XL" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Medium XL</span>
                  {this.renderPrice('DOOR_BWM', replacement.DOOR_BWM.Price)}
                </div>
              </div>
            </div>
            <div className="rep-doors-col">
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/GRANDE.png" alt="Large" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Large</span>
                  {this.renderPrice('DOOR_BNL', replacement.DOOR_BNL.Price)}
                </div>
              </div>
              <div className="rep-item">
                <img className="rep-item-img" src="/images/replacements/GRANDE.png" alt="Large XL" />
                <div className="rep-item-info">
                  <span className="rep-item-name">Large XL</span>
                  {this.renderPrice('DOOR_BWL', replacement.DOOR_BWL.Price)}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  replacement: state.replacements.replacement,
  error: state.replacements.error,
  loading: state.replacements.loading,
  auth: state.auth,
})

const mapDispatchToProps = dispatch => ({
  fetchReplacement: bindActionCreators(fetchReplacement, dispatch),
  updateReplacement: bindActionCreators(updateReplacement, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(replacementsView)
